import client from './index'
import store from '@/store'

const getDataWithParams = (url,request) => client['api'].get(url, {params: request})
const getAllData = (url) => client['api'].get(url)
const postData = (url,data) => client['api'].post(url,data)
const patchData = (url,data) => client['api'].patch(url,data)
const putData = (url,data) => client['api'].put(url,data)
const destroyData = (url) => client['api'].delete(url)
const uploadData = (url,data) => client['api'].post(url, data, {"headers": {"Content-Type": "multipart/form-data"},  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
}})
const downloadFile = (url, request) => client['api'].get(url, { params: request, responseType: 'blob'})
const errorHelper = (err) => {
    const error = err?.response?.data
    return {
        msg: error?.msg || 'An error occurred, please try again',
        status: error?.status || 0
    }
}
const getData = (url) => client['api'].get(url)
const getDataWithParamsCache = (url,request) => client['api'].get(url, {params: request, useCache: true})
const getDataCache = (url, params = {}) => client['api'].get(url,{ params, useCache: true })


export {
    getDataWithParams,
    getAllData,
    postData,
    patchData,
    destroyData,
    uploadData,
    downloadFile,
    putData,
    errorHelper,
    getData,
    getDataWithParamsCache,
    getDataCache,
}